import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=674c6202&"
import script from "./pie.vue?vue&type=script&lang=ts&"
export * from "./pie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('674c6202')) {
      api.createRecord('674c6202', component.options)
    } else {
      api.reload('674c6202', component.options)
    }
    module.hot.accept("./pie.vue?vue&type=template&id=674c6202&", function () {
      api.rerender('674c6202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Charts/pie.vue"
export default component.exports